import { Stack } from "@mui/material";
import { EliceButton } from "../../button";

export interface LayoutFooterSubmitProps {
  isRollback?: boolean;
  isSubmit?: boolean;
  disableRollback?: boolean;
  disableSubmit?: boolean;
  submitText?: string;
  rollbackText?: string;
  onRollback?: () => void;
  onSubmit?: () => void;
  submitButtonColor?: string;
  rollbackButtonColor?: string;
  submitTextColor?: string;
  buttonSize?: 'small' | 'medium' | 'large';
  rollbackTextColor?: string;
}

const LayoutFooterSubmit = ({
  isRollback = false,
  isSubmit = false,
  disableRollback = false,
  disableSubmit = false,
  submitText,
  rollbackText,
  onSubmit,
  buttonSize = 'medium',
  onRollback,
  submitButtonColor,
  rollbackButtonColor,
  submitTextColor = '#fff',
  rollbackTextColor,
}: LayoutFooterSubmitProps) => {
  return (
    <Stack direction="row" spacing={1}>
      {isRollback && (
        <EliceButton
          disabled={disableRollback}
          variant="outlined"
          size={buttonSize}
          customColor={rollbackButtonColor}
          textColor={rollbackTextColor}
          onClick={onRollback}
        >
          {rollbackText ?? "다시하기"}
        </EliceButton>
      )}
      {isSubmit && (
        <EliceButton
          disabled={disableSubmit}
          variant="contained"
          size={buttonSize}
          customColor={submitButtonColor}
          textColor={submitTextColor}
          onClick={onSubmit}
        >
          {submitText ?? "제출하기"}
        </EliceButton>
      )}
    </Stack>
  );
};

export default LayoutFooterSubmit;
